export default __webpack_public_path__ + "static/media/0x09211dc67f9fe98fb7bbb91be0ef05f4a12fa2b2.2e8f3f7e.webp";